import { BatchCreateType, BatchIdType, PayslipItemTypeType, PayslipType } from "types/payroll-types";
import { ApiCore } from "./axios"
import * as url from "./urls";
import { AxiosResponse } from "axios";
import { QuestionType } from 'types/appraisals-types';


import { LeaveDetailsType } from "pages/leaves/Leaves";
import { LeaveInfoType } from "features/leaves/RegisterLeaveTypeForm";
import { RequestLeaveType } from "features/leaves/RequestLeaveForm";
import { AssignMaxLeavesType } from "types/leaves-types";
import { DependantsDataType, EmployeeCreateType } from "types/employee-types";
import { EmployeeUpdateType } from "features/employees/EmployeeBioDataForm";
import { AppraisalFormCreateType } from "types/appraisals-types";

// Careers Imports
import { JobOpeningType } from "types/careers-types";
//Employee Utilization Types
import { WorkCategory, BulkApprovalRequest, Employee, UtilizationItem, UtilizationItemCreate,  EmployeeUtilization, CreateUtilizationRequest, UpdateUtilizationRequest, BulkApprovalResponse, PendingCount, UtilizationStats, UtilizationRecord, EmployeeUtilizationRequest} from "types/employee-utilization";
import { ClientAssignment, ClientUserLeave, ClientUserListItem } from "types/client-management-types";
import { Template, Question, CreateTemplateData, UpdateTemplateData, CreateQuestionData, UpdateQuestionData } from "types/template-builder-types";
import { AppraisalCycle, CreateAppraisalCycleData, UpdateAppraisalCycleData } from "types/appraisal-cycle-types";
import { AvailableCycle, AppraisalResponse, CreateAppraisalResponseData } from "types/appraisal-response-types";

export const api = new ApiCore();

export interface loginUserType {
  username: string;
  password: string;
}
export type authCodeType = string

interface ContractData {
  employee: string;
  clauses_in_contract: number[];
}



// AUTHENTICATION API CALLS
export const loginAPI = async (data: loginUserType) => {
  return await api.post(url.LOGIN_URL, data);
}

export const loginGoogleAPI = async (authCode: string) => {
  const data={
    'authorization_code': authCode,
    'company_name': 'telerelation',
  } 
  return await api.post(url.GOOGLE_LOGIN_URL, data);
}

// EMPLOYEE API CALLS
export const fetchEmployeeOwnProfileAPI = async () => {
  return await api.get(url.EMPLOYEE_PROFILE_URL);
}
export const fetchSpecificEmployeeAPI = async (employeeId: string) => {
  return await api.get(`${url.EMPLOYEES_URL}${employeeId}`);
}

export const getAllEmployees = async () => {
  return await api.get(url.GET_ALL_EMPLOYEES, {})
}
export const getEmployees = async (isActive: boolean) => {
  const isActiveParam = isActive ? "true" : "false";
  return await api.get(url.GET_ALL_EMPLOYEES + `?is_active=${isActiveParam}&page_size=150`, {});
};
export const fetchAllEmployeesAPI = async (
  searchTerm: string = '', 
  isActive: boolean | null = null,
  pageSize: number = 10
) => {
  const searchQuery = searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : '';
  let activeQuery = '';
  if (isActive === true) {
    activeQuery = '&is_active=true';
  } else if (isActive === false) {
    activeQuery = '&is_active=false';
  }
  
  return await api.get(url.GET_ALL_EMPLOYEES + `?page=1&page_size=${pageSize}${searchQuery}${activeQuery}`);
};

export const fetchEmployeePageAPI = async (pageUrl: string) => {
  return await api.get(pageUrl);
};

export const fetchEmployeesWithIncomeAPI = async () => {
  return await api.get(url.GET_ACTIVE_OR_RECENTLY_LEFT_EMPLOYEES);
}

export const updateEmployeeAPI = async (employeeId: string, data: EmployeeUpdateType) => {
  return await api.update(`${url.EMPLOYEES_URL}${employeeId}/`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const createEmployeeAPI = async (data: EmployeeCreateType) => {
  return await api.post(url.CREATE_EMPLOYEE_BY_USER, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateEmployeeByUserAPI = async (data: EmployeeCreateType) => {
  return await api.update(url.UPDATE_EMPLOYEE_BY_USER, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const getBanksAPI = async () => {
  return await api.get(url.GET_ALL_BANKS);
}

// DEPENDENTS API CALLS
export const createDependentsAPI = async (data: DependantsDataType[]) => {
  return await api.post(url.DEPENDENTS_BULK_CREATE, data);
}

// CONTRACTS API CALLS
export const getClausesAPI = async () => {
  return await api.get(url.GET_CLAUSES_URL)
}

export const createContractAPI = async (contractData: ContractData): Promise<AxiosResponse<any>> => {
  return api.post(url.CONTRACTS_URL, contractData);
};

export const getContractAPI = async (id: string) => {
  return await api.get(url.CONTRACTS_URL + id + "/")
}

export const getMyContractAPI = async () => {
  return await api.get(url.MY_CONTRACT_URL)
}

// LEAVES API CALLS
export const getEmployeeLeavesInfo = async (id: string) => {
  return await api.get(url.GET_EMPLOYEE_LEAVES_INFO + id + "/", {})
}

export const getEmployeeLeavesDetails = async (id: string) => {
  return await api.get(`${url.GET_EMPLOYEE_LEAVES_DETAILS}${id}/`, {})
}

export const getEmployeeLeavesInfoByUser = async () => {
  return await api.get(url.GET_EMPLOYEE_LEAVES_INFO, {})
}

export const getEmployeeLeavesDetailsByUser = async () => {
  return await api.get(url.GET_EMPLOYEE_LEAVES_DETAILS, {})
}
export const getEmployeeLeavesTypes = async (searchTerm?: string) => {
  const params = searchTerm ? { search: searchTerm } : undefined;
  return await api.get(url.GET_EMPLOYEE_LEAVE_TYPES, params ? { params } : {})
}
export const getAllEmployeeLeavesInfo = async () => {
  return await api.get(url.ALL_LEAVES_INFO, {})
}

export const getPendingLeavesDetails = async () => {
  return await api.get(`${url.LEAVE_DETAILS}?leave_status__in=P,MA,CA`, {})
}

export const getApprovedLeavesDetails = async () => {
  return await api.get(`${url.LEAVE_DETAILS}?leave_status=A`, {})
}
export const getManagerApprovedLeaves = async () => {
  return await api.get(`${url.GET_SUBORDINATES_LEAVES}?leave_status=MA`, {})
}
export const getManagerDeclinedLeaves = async () => {
  return await api.get(`${url.GET_SUBORDINATES_LEAVES}?leave_status=MD`, {})
}

export const getManagerPendingLeaves = async () => {
  return await api.get(`${url.GET_SUBORDINATES_LEAVES}?leave_status=P`, {})
}

export const getSubordinateLeaveDetails = async (id: string) => {
  return await api.get(`${url.GET_SUBORDINATE_LEAVE}?leave_id=${id}`, {})
}


export const managerApproveLeave = async (leaveId: number, action: 'approve' | 'decline', comments: string): Promise<AxiosResponse> => {
  return await api.post(`/leaves/${leaveId}/manager-action/`, { action, comments });
};
export const postManagerApproveLeave = async (id: string, comments: string) => {
  const data = {
    action: 'approve',
    comments: comments
  };
  return await api.post(`${url.LEAVE_DETAILS}${id}/manager_action/`, data);
};

export const postManagerDeclineLeave = async (id: string, comments: string) => {
  const data = {
    action: 'decline',
    comments: comments
  };
  return await api.post(`${url.LEAVE_DETAILS}${id}/manager_action/`, data);
};

export const postApproveLeave = async (id: string, comments: string) => {
  const data = {
    action: 'approve',
    comments: comments
  };
  return await api.post(`${url.LEAVE_DETAILS}${id}/hr_action/`, data);
};

export const postDeclineLeave = async (id: string, comments: string) => {
  const data = {
    action: 'decline',
    comments: comments
  };
  return await api.post(`${url.LEAVE_DETAILS}${id}/hr_action/`, data);
};

export const postClientUserActionLeave = async (id: string, action: 'approve' | 'reject', comments: string) => {
  const data = {
    action: action,
    comments: comments
  };
  return await api.post(`${url.LEAVE_DETAILS}${id}/clientuser_action/`, data);
};

export const getDeclinedLeavesDetails = async () => {
  return await api.get(`${url.LEAVE_DETAILS}?leave_status__in=D,MD,CR`, {})
}

export const getRemainingLeavesTypesInfo = async (employeeId?: string) => {
  if (employeeId){
    return await api.get(`${url.REMAINING_LEAVES_TYPES_INFO}${employeeId}/`)
  } else {
    return await api.get(url.REMAINING_LEAVES_TYPES_INFO)
  }
}


export const getLeaveDetails = async (id: string) => {
  return await api.get(url.LEAVE_DETAILS + id + "/", {})
}

export const postRequestLeave = async (leaveData: RequestLeaveType) => {
  const data = {
    "leave_info_id": leaveData.leave_info_id,
    "start_date": leaveData.start_date,
    "end_date": leaveData.end_date,
    "reason": leaveData.reason,
  };
  return await api.post(url.REQUEST_LEAVE, data);
}

export const postHRAddLeave = async (leaveData: RequestLeaveType & { employee_id: number }) => {
  const data = {
    employee_id: leaveData.employee_id,
    leave_info_id: leaveData.leave_info_id,
    start_date: leaveData.start_date,
    end_date: leaveData.end_date,
    reason: leaveData.reason,
    is_hr_approved: true
  };
  return await api.post(url.HR_ADD_LEAVE, data);
};
export const deleteHRLeave = async ({ leave_id }: { leave_id: number }) => {
  return await api.delete(`${url.HR_DELETE_LEAVE}?leave_id=${leave_id}`);
};


export const getLeaveTypes = async () => {
  return await api.get(url.LEAVE_TYPE);
}

export const getLeaveTypeById = async (id: any) => {
  return await api.get(`${url.LEAVE_TYPE}/${id}/`);
};

export const postLeaveType = async (leaveData: LeaveInfoType) => {
  const data = {
    "description": leaveData.description,
    "is_paid": leaveData.is_paid,
  };
  return await api.post(url.LEAVE_TYPE, data);
}

// export const postLeaveInfo = async (leaveData: AssignMaxLeavesType) => {
//   const data = {
//     "employee": leaveData.employee,
//     "max_leaves_allowed": leaveData.max_leaves_allowed,
//     "leave_type": leaveData.leave_type,
//     "period_start": leaveData.period_start,
//     "period_end": leaveData.period_end,
//   };
//   return await api.post(url.LEAVE_INFO, data);
// }

export const postBulkLeaveInfo = async (leaveData: AssignMaxLeavesType) => {
  return await api.post(`${url.LEAVE_INFO}bulk_assign/`, {
    employees: leaveData.employees.map(id => parseInt(id, 10)),
    leave_types: leaveData.leave_types.map(id => parseInt(id, 10)),
    max_leaves_allowed: parseInt(leaveData.max_leaves_allowed, 10),
    period_start: leaveData.period_start,
    period_end: leaveData.period_end,
  });
};


export const getLeaveDetail = async (id: string): Promise<LeaveDetailsType> => {
  const response = await api.get(`${url.LEAVE_DETAILS}${id}/`);
  return response.data;
};

export const getEmployeeLeaveInfoByType = async (leaveTypeId: any) => {
  return await api.get(`${url.LEAVE_INFO}?leave_type=${leaveTypeId}`);
};


// PAYROLL API CALLS
export const fetchNonAutoPayslipLineItemTypesAPI = async () => {
  return await api.get(url.PAYSLIP_NON_AUTO_ITEM_TYPES_URL);
}

export const payslipCreateAPI = async (data: PayslipType) => {
  return await api.post(url.PAYSLIP_URL, data);
}

export const fetchAllPayslipsAPI = async (pageSize: number, searchTerm = '') => {
  const searchQuery = searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : '';
  return await api.get(url.PAYSLIP_URL + `?page_size=${pageSize}${searchQuery}`);
}
export const deletePayslipAPI = async (payslipId: number) => {
  return await api.delete(url.PAYSLIP_URL + `${payslipId}/`);
};

export const fetchPayslipsPageAPI = async (pageUrl:string) => {
  return await api.get(pageUrl);
}

export const fetchSpecificPayslipAPI = async (payslipId: string) => {
  return await api.get(url.PAYSLIP_URL + `${payslipId}`);
}

export const fetchPayslipPdfUrlAPI = async (payslipId: PayslipType["id"]) => {
  return await api.get(url.PAYSLIP_PDF_URL + `${payslipId}`);
}

export const fetchSpecificBatchAPI = async (batchId: BatchIdType) => {
  return await api.get(url.PAYSLIP_BATCH_URL + `${batchId}`);
}
export const fetchAllBatchesWithSearchAPI = async (pageSize: number = 20, searchTerm: string = '') => {
  const searchQuery = searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : '';
  return await api.get(url.PAYSLIP_BATCH_URL + `?page=1&page_size=${pageSize}${searchQuery}`);
};

// Fetch specific page using URL (for pagination)
export const fetchBatchPageAPI = async (pageUrl: string) => {
  return await api.get(pageUrl);
};
export const fetchAllBatchesAPI = async () => {
  return await api.get(url.PAYSLIP_BATCH_URL);
}

export const fetchEmployeeSpecificPayslipsAPI = async (employeeId: string) => {
  return await api.get(url.PAYSLIPS_EMPLOYEE_URL + `${employeeId}`);
}

export const payslipBatchCreateAPI = async (data: BatchCreateType) => {
  return await api.post(url.PAYSLIP_BATCH_URL, data);
}

export const payslipsStatusUpdateAPI = async (payslipIds: number[], status: string) => {
  return await api.post(url.PAYROLL_URL + `payslips/update-status/`, { payslipIds, status });
}
export const fetchPayslipLineItemTypesAPI = async () => {
  return await api.get(url.PAYSLIP_LINE_ITEM_TYPES_URL);
}
export const payslipLineItemTypeCreateAPI = async (data: PayslipItemTypeType) => {
  return await api.post(url.PAYSLIP_LINE_ITEM_TYPES_URL, data);
}
export const fetchMyPayslipsWithSearchAPI = async (pageSize: number = 20, searchTerm: string = '') => {
  const searchQuery = searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : '';
  return await api.get(url.MY_PAYSLIPS_URL + `?page=1&page_size=${pageSize}${searchQuery}`);
};

export const fetchMyPayslipsPageAPI = async (pageUrl: string) => {
  return await api.get(pageUrl);
}
export const fetchMyPayslipsAPI = async () => {
  return await api.get(url.MY_PAYSLIPS_URL);
}
export const fetchPayslipBlobAPI = async (payslipId: string) => {
  return await api.getBlob(url.PAYSLIP_PDF_URL+ `${payslipId}`);
}

export const fetchPayrollReportsAPI = async (
  startDate: Date | null,
  endDate: Date | null
) => {
  const formatDate = (date: Date | null) => {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const params = {
    start_date: formatDate(startDate),
    end_date: formatDate(endDate),
  };

  return await api.get(url.PAYROLL_REPORTS_URL, {
    responseType: "blob",
    params: params,
  });
};

export const fetchPayrollTaxReportAPI = async (
  startDate: Date | null,
  endDate: Date | null
) => {
  const formatDate = (date: Date | null) => {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const params = {
    start_date: formatDate(startDate),
    end_date: formatDate(endDate),
  };

  return await api.get(url.PAYROLL_TAX_REPORT_URL, {
    responseType: "blob",
    params: params,
  });
};

// Appraisals API CALLS

export const getAllAppraisalFormsAPI = async (status: string = 'active') => {
  const queryParam = status === 'all' ? '' : `?is_active=${status === 'active'}`;
  return await api.get(`${url.GET_APPRAISAL_FORM}${queryParam}`);
};

export const getAssignedFormsForUser = async () => {
  return await api.get(url.GET_ASSIGNED_FORMS_FOR_USER);
}

export const getFullAppraisalForm = async (id: string) => {
  return await api.get(`${url.GET_APPRAISAL_FORM}${id}/full-form/`);
}

export const getCompletedFormsForUser = async () => {
  return await api.get(url.GET_COMPLETED_FORMS_FOR_USER);
}

export const assignFormsToEmployeesAPI = async (data: { forms: number[], employees: number[] }) => {
  return await api.post(url.ASSIGN_FORMS_URL, data);
};

// export const getAllAppraisalFormsAPI = async () => {
//   return await api.get(url.GET_APPRAISAL_FORM);
// };

export const createAppraisalFormAPI = async (data: AppraisalFormCreateType) => {
  return await api.post(url.GET_APPRAISAL_FORM, data);
};

// Get all questions
export const getAllQuestionsAPI = async () => {
  return await api.get(url.QUESTIONS_URL);
};

// Create a new question
export const createQuestionAPI = async (data: QuestionType) => {
  return await api.post(url.QUESTIONS_URL, data);
};

// Update a question
export const updateQuestionAPI = async (id: string | number, data: any) => {
  return await api.update(`${url.QUESTIONS_URL}${id}/`, data);
};

// Delete a question
export const deleteQuestionAPI = async (id: string | number) => {
  return await api.delete(`${url.QUESTIONS_URL}${id}/`);
};

// Get a single question by ID
export const getQuestionByIdAPI = async (id: string | number) => {
  return await api.get(`${url.QUESTIONS_URL}${id}/`);
};

export const getAllResponsesAPI = async () => {
  return await api.get(url.APPRAISAL_RESPONSES_URL);
};

export const getResponseByIdAPI = async (id: string | number) => {
  return await api.get(`${url.APPRAISAL_RESPONSES_URL}${id}/`);
};


export const postAppraisalForm = async (data: any) => {
  return await api.post(url.POST_APPRAISAL_FORM, data);
}

export const deleteAppraisalFormAPI = async (formId: number) => {
  return await api.delete(`${url.DELETE_APPRAISAL_FORM_URL}${formId}/`);
};

export const updateAppraisalFormAPI = async (id: string | number, data: any) => {
  return await api.update(`${url.DELETE_APPRAISAL_FORM_URL}${id}/`, data);
};

export const setAppraisalFormStatusAPI = async (id: string | number, status: boolean) => {
  return await api.post(`${url.SET_FORM_STATUS_URL}${id}/set-status/`, { is_active: status });
};

// Careers API Helpers
// export const getAllJobOpenings = async () => {
//   return await api.get(url.GET_ALL_JOB_OPENINGS);
// }
export const getAllJobOpenings = async () => {
  return await api.get(url.GET_ALL_JOB_OPENINGS);
}

// export const createJobOpening = async (data: JobOpeningType) => {
//   return await api.post(url.GET_ALL_JOB_OPENINGS, data);
// }
export const createJobOpening = async (data: any) => {
  return await api.post(url.GET_ALL_JOB_OPENINGS, data);
}
export const getJobDetails = async (slug: string) => {
  return await api.get(`${url.GET_ALL_JOB_OPENINGS}${slug}/`);
}

// export const getJobDetails = async (jobId: string) => {
//   return await api.get(`${url.GET_ALL_JOB_OPENINGS}${jobId}/`);
// }

// export const editJobDetails = async (data: JobOpeningType, jobId: string) => {
//   return await api.update(`${url.GET_ALL_JOB_OPENINGS}${jobId}/`, data);
// }
export const editJobDetails = async (data: JobOpeningType, slug: string) => {
  return await api.update(`${url.GET_ALL_JOB_OPENINGS}${slug}/`, data);
}

export const getAllApplicants = async () => {
  return await api.get(url.GET_ALL_APPLICANTS);
}

export const createApplicant = async (data: {
  name: string;
  email: string;
  city: string;
  contact: string;
  notes?: string;
}) => {
  return await api.post(url.GET_ALL_APPLICANTS, data);
}

export const getAllJobApplications = async () => {
  return await api.get(url.GET_ALL_JOB_APPLICATIONS);
}

export const createJobApplication = async (formData: FormData) => {
  return await api.post(url.GET_ALL_JOB_APPLICATIONS, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const getJobApplicationDetails = async (applicationId: string) => {
  return await api.get(`${url.GET_ALL_JOB_APPLICATIONS}${applicationId}/`);
}

export const getApplicantJobApplications = async (applicantId: string) => {
  return await api.get(`${url.GET_ALL_APPLICANTS}${applicantId}/jobs-applied/`);
}

export const updateJobApplicationDetails = async (applicationId: string, data: any) => {
  return await api.update(`${url.GET_ALL_JOB_APPLICATIONS}${applicationId}/update-note/`, data);
}

export const getApplicantDetails = async (applicantId: string) => {
  return await api.get(`${url.GET_ALL_APPLICANTS}${applicantId}/`);
}

export const updateApplicantDetails = async (applicantId: string, data: any) => {
  return await api.update(`${url.GET_ALL_APPLICANTS}${applicantId}/update-note/`, data);
}

export const getAllJobApplicationsStatus = async () => {
  return await api.get(url.GET_STATUS_CHOICES);
}

export const updateJobApplicationStatus = async (applicationId: string, status: string) => {
  return await api.update(`${url.GET_ALL_JOB_APPLICATIONS}${applicationId}/update-status/`, {status});
}

export const getAllSkills = async () => {
  return await api.get(url.GET_SKILLS);
}

export const postSkill = async (data: any) => {
  return await api.post(url.GET_SKILLS, data);
}

export const getDepartments = async () => {
  return await api.get(url.DEPARTMENTS_URL);
}

// Policy API CALLS

export const getAllPolicies = async () => {
  return await api.get(url.POLICIES_URL);
};

export const createPolicy = async (formData: any) => {
  return await api.post(url.POLICIES_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    }});
};

export const deletePolicy = async (policyId: number) => {
  return await api.delete(`${url.POLICIES_URL}${policyId}/`);
};
//Bulletin API CALLS
export const getAllHolidays = async () => {
  return await api.get(url.GET_ALL_HOLIDAYS);
}

export const getAllAnnouncements = async () => {
  return await api.get(url.GET_ALL_ANNOUNCEMENTS);
}
export const createHoliday = async (holidayData: { name: string; date: string; }) => {
  return await api.post(url.GET_ALL_HOLIDAYS, holidayData);
}

export const createAnnouncement = async (announcementData: { title: string; description: string; }) => {
  return await api.post(url.GET_ALL_ANNOUNCEMENTS, announcementData);
}
export const deleteAnnouncement = async (announcementId: number) => {
  return await api.delete(`${url.GET_ALL_ANNOUNCEMENTS}${announcementId}/`);
}
export const deleteHoliday = async (holidayId: number) => {
  return await api.delete(`${url.GET_ALL_HOLIDAYS}${holidayId}/`);
}

export const batchCreateEmployeeUtilizations = async (
  records: EmployeeUtilizationRequest[]
): Promise<AxiosResponse> => {
  const response = await api.post(url.CREATE_MANAGER_UTILIZATION_BATCH, records);
  return response;
};
export const createWorkCategory = async (data: { type: string }): Promise<WorkCategory> => {
  const response = await api.post(url.CREATE_MANAGER_WORK_CATEGORY, data);
  return response.data as WorkCategory;
};

export const getWorkCategories = async (): Promise<WorkCategory[]> => {
  const response = await api.get(url.GET_WORK_CATEGORIES);
  return response.data as WorkCategory[];
};

// Employee Management
export const getEmployeeSubordinates = async (): Promise<Employee[]> => {
  const response = await api.get(url.GET_EMPLOYEE_SUBORDINATES);
  return response.data as Employee[];
};

export const getAllEmployeesForReviewsAssignment = async (): Promise<Employee[]> => {
  const response = await api.get(url.GET_ALL_EMPLOYEES_FOR_REVIEW_ASSIGNMENT);
  return response.data as Employee[];
};


export const createEmployeeUtilization = async (data: CreateUtilizationRequest): Promise<EmployeeUtilization> => {
  const response = await api.post(url.CREATE_EMPLOYEE_UTILIZATION, data);
  return response.data as EmployeeUtilization;
};
export const getAllEmployeeUtilizationDetail = async (
  startDate: Date | null,
  endDate: Date | null,
  managerId: number | null
) => {
  const formatDate = (date: Date | null) => {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  try {
    // Build params object with all filters
    const params: any = {};
    
    if (startDate) {
      params.start_date = formatDate(startDate);
    }
    if (endDate) {
      params.end_date = formatDate(endDate);
    }
    if (managerId) {
      params.manager_id = managerId.toString();
    }

    // Make API call with params
    const response = await api.get(url.MANAGER_EMPLOYEE_UTILIZATIONS, { params });
    console.log('Manager Utilizations Response:', response);

    // Ensure we don't have duplicate entries
    const uniqueUtilizations = response.data.reduce((acc: any[], curr: any) => {
      const exists = acc.find(item => item.id === curr.id);
      if (!exists) {
        acc.push(curr);
      }
      return acc;
    }, []);

    return { data: uniqueUtilizations };
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
}

// Manager Operations
export const approveEmployeeUtilization = async (id: number, status: 'approved' | 'declined'): Promise<EmployeeUtilization> => {
  const response = await api.update(`${url.APPROVE_UTILIZATION}${id}/approve/`, { status });
  return response.data as EmployeeUtilization;
};

export const bulkApproveUtilizations = async (data: BulkApprovalRequest): Promise<BulkApprovalResponse> => {
  const response = await api.post(url.BULK_APPROVE_UTILIZATIONS, data);
  console.log("Bulk Approval Response:", response.data);
  return response.data as BulkApprovalResponse;
};



// Employee Operations
export const getMyUtilizations = async (): Promise<EmployeeUtilization[]> => {
  const response = await api.get(url.GET_MY_UTILIZATIONS);
  return response.data as EmployeeUtilization[];
};

// Utility functions
export const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'approved':
      return 'success';
    case 'declined':
      return 'error';
    default:
      return 'default';
  }
};

export const getStatusText = (status: string): string => {
  switch (status) {
    case 'pending':
      return 'Pending';
    case 'approved':
      return 'Manager Approved';
    case 'declined':
      return 'Manager Declined';
    default:
      return status;
  }
};

export const calculateTotalHours = (items: UtilizationItem[]): number => {
  return items.reduce((total, item) => total + item.utilization_hours, 0);
};

export const validateUtilizationForm = (items: UtilizationItemCreate[]): string[] => {
  const errors: string[] = [];
  
  if (!items || items.length === 0) {
    errors.push('At least one utilization item is required');
  }
  
  const totalHours = calculateTotalHours(items);
  if (totalHours > 12) {
    errors.push('Total hours cannot exceed 12 hours per day');
  }
  
  items.forEach((item, index) => {
    if (!item.type) {
      errors.push(`Project type is required for item ${index + 1}`);
    }
    if (!item.utilization_hours || item.utilization_hours < 1 || item.utilization_hours > 12) {
      errors.push(`Hours must be between 1 and 12 for item ${index + 1}`);
    }
  });
  
  return errors;
};
export const getAllManagers = async () => {
  return await api.get(url.GET_ALL_MANAGERS);
}

// Organization Structure API
export const getOrganizationStructure = async (employeeId: string) => {
  return await api.get(url.GET_ORGANIZATION_STRUCTURE + `${employeeId}/employee_path/`);
}

export const getDepartment = async () => {
  return await api.get(url.GET_ALL_DEPARTMENTS);
}
export const createDepartment = async (Departmentdata: { name: string;} ) => {
  return await api.post(url.GET_ALL_DEPARTMENTS, Departmentdata);
}
export const getDepartmentWithLevel = async () => {
  return await api.get(url.GET_DEPARTMENT_WITH_LEVELS);
}

export const addDepartmentTitles = async (id: string, data: any) => {
  return await api.post(url.GET_ENHANCED_DEPARTMENTS + `${id}/add_titles_to_levels/`, data);
}
export const getCompleteDepartment = async (id: string) => {
  return await api.get(url.GET_DEPARTMENT_LEVELS + `${id}/with_levels_and_titles/`);
}

export const getLevels = async () => {
  return await api.get(url.GET_ALL_LEVELS);
}
export const createDepartmentLevel = async (data: any) => {
  return await api.post(url.CREATE_DEPARTMENT_LEVELS, data);
}

export const createLevel = async (data: any) => {
  return await api.post(url.CREATE_LEVELS, data);
}
export const getOrganizationOverview = async () => {
  return await api.get(url.GET_ORGANIZATION_VIEW);
}
export const getOrganizationTree = async () => {
  return await api.get(url.GET_ORGANIZATION_TREE);
}


//Notification APIs
export const fetchNotifications = async () => {
  return await api.get(url.GET_ALL_NOTIFICATIONS);
}
export const fetchUnreadNotifications = async () => {
  return await api.get(url.GET_UNREAD_NOTIFICATIONS);
}
export const fetchNotificationById = async (id: number) => {
  return await api.get(`${url.GET_ALL_NOTIFICATIONS}${id}/`);
}
export const markNotificationAsRead = async (id: number) => {
  return await api.post(`${url.GET_ALL_NOTIFICATIONS}${id}/mark_as_read/`);
}
export const deleteAllNotifications = async () => {
  return await api.delete(`${url.GET_ALL_NOTIFICATIONS}/delete_all/`);
}
export const deleteNotification = async (id: number) => {
  return await api.delete(`${url.GET_ALL_NOTIFICATIONS}${id}/`);
}

// Team Leave Calendar API
export const getTeamLeaveCalendar = async (params?: {
  start_date?: string;
  end_date?: string;
  status?: string;
  employee_id?: number;
}) => {
  const queryString = params ? `?${new URLSearchParams(params as any).toString()}` : '';
  return await api.get(`${url.TEAM_LEAVE_CALENDAR}${queryString}`);
}

// Test APIs
export const verifyTestLink = async (testToken: string) => {
  return await api.get(`${url.TEST_SESSIONS}${testToken}/verify/`);
}

export const startTest = async (testToken: string) => {
  return await api.post(`${url.TEST_SESSIONS}${testToken}/start/`);
}

export const getCurrentState = async (testToken: string) => {
  return await api.get(`${url.TEST_SESSIONS}${testToken}/current-state/`);
}

export const getTestProgression = async (testToken: string) => {
  return await api.get(`${url.TEST_SESSIONS}${testToken}/test-progression/`);
}

export const submitAnswer = async (testToken: string, data: { test_question_id: number; selected_option: string }) => {
  return await api.post(`${url.TEST_SESSIONS}${testToken}/submit-answer/`, data);
};

export const completeTest = async (testToken: string) => {
  return await api.post(`${url.TEST_SESSIONS}${testToken}/complete/`);
}

export const getResult = async (testToken: string) => {
  return await api.get(`${url.TEST_SESSIONS}${testToken}/result/`);
}
export const fetchAllQuestions = async () => {
  return await api.get(url.QUESTIONS);
}

export const createQuestion = async (data: FormData) => {
  return await api.post(`${url.QUESTIONS}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateQuestion = async (id: number, data: FormData) => {
  return await api.patch(`${url.QUESTIONS}${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteQuestion = async (id: number) => {
  return await api.delete(`${url.QUESTIONS}${id}/`);
}

export const toggleQuestionStatus = async (id: number, is_active: boolean) => {
  return await api.patch(`${url.QUESTIONS}${id}/`, { is_active });
}

// Video Test APIs
export const verifyVideoTestLink = async (testToken: string) => {
  return await api.get(`${url.VIDEO_TEST_SESSIONS}${testToken}/verify/`);
}

export const startVideoTest = async (testToken: string) => {
  return await api.post(`${url.VIDEO_TEST_SESSIONS}${testToken}/start/`);
}

export const getVideoTestCurrentState = async (testToken: string) => {
  return await api.get(`${url.VIDEO_TEST_SESSIONS}${testToken}/current-state/`);
}

export const getVideoTestQuestions = async (testToken: string) => {
  return await api.get(`${url.VIDEO_TEST_SESSIONS}${testToken}/questions/`);
}

export const uploadVideoResponse = async (testToken: string, formData: FormData) => {
  return await api.post(`${url.VIDEO_TEST_SESSIONS}${testToken}/upload/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const completeVideoTest = async (testToken: string) => {
  return await api.post(`${url.VIDEO_TEST_SESSIONS}${testToken}/complete/`);
}

export const fetchVideoQuestions = async () => {
  return await api.get(url.VIDEO_TEST_QUESTIONS);
}

export const createVideoQuestion = async (data: { question_text: string; question_order: number; time_limit_seconds: number }) => {
  return await api.post(url.VIDEO_TEST_QUESTIONS, data);
}

export const updateVideoQuestion = async (id: number, data: { question_text?: string; question_order?: number; time_limit_seconds?: number; is_active?: boolean }) => {
  return await api.patch(`${url.VIDEO_TEST_QUESTIONS}${id}/`, data);
}

export const deleteVideoQuestion = async (id: number) => {
  return await api.delete(`${url.VIDEO_TEST_QUESTIONS}${id}/`);
}

export const getVideoTestReviews = async (status?: string) => {
  const statusQuery = status ? `?status=${status}` : '';
  return await api.get(`${url.VIDEO_TEST_SESSIONS.replace('video-test-sessions/', 'reviews/')}${statusQuery}`);
}

export const getVideoTestResponses = async (testToken: string) => {
  return await api.get(`${url.VIDEO_TEST_SESSIONS}${testToken}/responses/`);
}

export const updateVideoTestNotes = async (testToken: string, notes: string) => {
  return await api.patch(`${url.VIDEO_TEST_SESSIONS}${testToken}/update-notes/`, { reviewer_notes: notes });
}

export const createTestSessionForApplication = async (jobApplicationId: string) => {
  return await api.post(`${url.TEST_SESSIONS}create-for-application/`, { job_application_id: jobApplicationId });
}

export const createVideoTestSessionForApplication = async (jobApplicationId: string) => {
  return await api.post(`${url.VIDEO_TEST_SESSIONS}create-for-application/`, { job_application_id: jobApplicationId });
}

// General Questionnaire APIs
export const fetchGeneralQuestions = async () => {
  return await api.get(url.GENERAL_QUESTIONNAIRE_QUESTIONS);
};

export const createGeneralQuestion = async (data: { question_text: string; question_order: number; is_active?: boolean }) => {
  return await api.post(url.GENERAL_QUESTIONNAIRE_QUESTIONS, data);
};

export const updateGeneralQuestion = async (id: number, data: { question_text?: string; question_order?: number; is_active?: boolean }) => {
  return await api.patch(`${url.GENERAL_QUESTIONNAIRE_QUESTIONS}${id}/`, data);
};

export const deleteGeneralQuestion = async (id: number) => {
  return await api.delete(`${url.GENERAL_QUESTIONNAIRE_QUESTIONS}${id}/`);
};

export const verifyGeneralQuestionnaireLink = async (testToken: string) => {
  return await api.get(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/verify/`);
};

export const startGeneralQuestionnaire = async (testToken: string) => {
  return await api.post(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/start/`);
};

export const getGeneralQuestionnaireCurrentState = async (testToken: string) => {
  return await api.get(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/current-state/`);
};

export const getGeneralQuestionnaireQuestions = async (testToken: string) => {
  return await api.get(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/questions/`);
};

export const submitGeneralQuestionResponse = async (testToken: string, data: { question_id: number; answer_text: string; attachment?: File }) => {
  const formData = new FormData();
  formData.append('question_id', data.question_id.toString());
  formData.append('answer_text', data.answer_text);
  if (data.attachment) {
    formData.append('attachment', data.attachment);
  }
  return await api.post(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/submit-response/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Client Management APIs
export const fetchClientUserProfileAPI = async () => {
  return await api.get(url.CLIENT_USERS_URL + "me/");
};

export const fetchClientProfileAPI = async () => {
  return await api.get(url.CLIENTS_URL + "me/");
};

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const getMyAssignedEmployees = async (
  searchTerm: string = '',
  pageSize: number = 10,
  pageUrl?: string
) => {
  if (pageUrl) {
    return await api.get(pageUrl);
  }
  const params: any = {
    page_size: pageSize,
  };
  if (searchTerm) {
    params.search = searchTerm;
  }
  return await api.get(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL + "by-current-user/", { params });
};

export const getAssignmentDetail = async (assignmentId: number) => {
  return await api.get(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL + `${assignmentId}/`);
};

export const getClientUserEmployeeLeaves = async (employeeId: string | number, params?: {
  start_date?: string;
  end_date?: string;
  leave_status?: string;
  page_size?: number;
  page?: number;
}, pageUrl?: string) => {
  if (pageUrl) {
    return await api.get(pageUrl);
  }
  const config = params ? { params } : {};
  return await api.get(url.CLIENT_USER_LEAVES_URL + `employee/${employeeId}/`, config);
};

export const getClientUserLeaveDetail = async (leaveId: string | number) => {
  return await api.get(url.CLIENT_USER_LEAVES_URL + `${leaveId}/`);
};

export const getClientUserEmployeeInfo = async (employeeId: string | number) => {
  return await api.get(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL + `employee/${employeeId}/minimal/`);
};

export const getAllAssignedEmployeesLeaves = async (params?: {
  employee_id?: number;
  start_date?: string;
  end_date?: string;
  leave_status?: string;
  search?: string;
  page_size?: number;
  page?: number;
}, pageUrl?: string) => {
  if (pageUrl) {
    return await api.get(pageUrl);
  }
  const config = params ? { params } : {};
  return await api.get(url.CLIENT_USER_LEAVES_URL + "all-assigned-employees/", config);
};

export const getClientUserLeaves = async (params?: {
  employee_id?: number;
  start_date?: string;
  end_date?: string;
  leave_status?: string;
  search?: string;
  page_size?: number;
  page?: number;
}, pageUrl?: string) => {
  if (pageUrl) {
    return await api.get(pageUrl);
  }
  const config = params ? { params } : {};
  return await api.get(url.CLIENT_USER_LEAVES_URL + "all-assigned-employees/", config);
};

export const getClientUserLeavesAll = async (params?: {
  employee_id?: number;
  start_date?: string;
  end_date?: string;
  leave_status?: string;
}) => {
  const config = params ? { params } : {};
  return await api.get(url.CLIENT_USER_LEAVES_URL + "all-assigned-employees/all/", config);
};

// Admin Client Management APIs
export const fetchClientUsersAPI = async (
  searchTerm: string = "",
  isActive: boolean | null = null,
  pageSize: number = 10
) => {
  const params: any = {
    page: 1,
    page_size: pageSize,
  };

  if (searchTerm) {
    params.search = searchTerm;
  }
  if (isActive !== null) {
    params.is_active = isActive;
  }

  return await api.get(url.CLIENT_USERS_URL, { params });
};

export const fetchClientUsersPageAPI = async (pageUrl: string) => {
  return await api.get(pageUrl);
};

export const getClientUserAssignmentsCount = async (clientUserId: number): Promise<number> => {
  const params = {
    client_user: clientUserId,
    page: 1,
    page_size: 1,
  };
  const response = await api.get(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL, {
    params,
  });
  return response.data?.count ?? 0;
};

export const createEmployeeClientAssignmentAPI = async (employeeId: number, clientUserId: number) => {
  const payload = {
    employee_id: employeeId,
    client_user_id: clientUserId,
  };
  return await api.post(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL, payload);
};

export const deleteEmployeeClientAssignmentAPI = async (assignmentId: number) => {
  return await api.delete(`${url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL}${assignmentId}/`);
};

//Noted
export const updateClientUserStatusAPI = async (clientUserId: number, isActive: boolean) => {
  return await api.patch(`${url.CLIENT_USERS_URL}${clientUserId}/`, { is_active: isActive });
};

export const createClientAPI = async (formData: FormData) => {
  return await api.post(url.CLIENTS_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const completeGeneralQuestionnaire = async (testToken: string) => {
  return await api.post(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/complete/`);
};

export const getGeneralQuestionnaireResponses = async (testToken: string) => {
  return await api.get(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/responses/`);
};

export const updateGeneralQuestionnaireNotes = async (testToken: string, notes: string) => {
  return await api.patch(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}${testToken}/update-notes/`, { reviewer_notes: notes });
};

export const getGeneralQuestionnaireReviews = async (status?: string) => {
  const statusQuery = status ? `?status=${status}` : '';
  return await api.get(`${url.GENERAL_QUESTIONNAIRE_SESSIONS.replace('questionnaire-sessions/', 'reviews/')}${statusQuery}`);
};

export const createGeneralQuestionnaireSessionForApplication = async (jobApplicationId: string) => {
  return await api.post(`${url.GENERAL_QUESTIONNAIRE_SESSIONS}create-for-application/`, { job_application_id: jobApplicationId });
};

export const fetchClientUserDetailAPI = async (clientUserId: number) => {
  return await api.get(`${url.CLIENT_USERS_URL}${clientUserId}/`);
};

export const getClientUserAssignmentsAPI = async (
  clientUserId: number,
  pageSize: number = 10,
  pageUrl?: string
) => {
  if (pageUrl) {
    return await api.get(pageUrl);
  }
  const params: any = {
    client_user: clientUserId,
    page_size: pageSize,
  };
  return await api.get(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL, { params });
};

export const getAllClientsAPI = async () => {
  return await api.get(url.CLIENTS_URL + "all/");
};

export const updateClientUserClientAPI = async (clientUserId: number, clientId: number) => {
  return await api.patch(`${url.CLIENT_USERS_URL}${clientUserId}/`, { client: clientId });
};

export const getClientManagementStats = async (): Promise<{
  totalClients: number;
  assignedEmployees: number;
}> => {
  const [clientsRes, assignmentsRes] = await Promise.all([
    api.get(url.CLIENTS_URL, { params: { page: 1, page_size: 1 } }),
    api.get(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL, { params: { page: 1, page_size: 1 } }),
  ]);

  return {
    totalClients: clientsRes.data?.count ?? 0,
    assignedEmployees: assignmentsRes.data?.count ?? 0,
  };
};


// New Functions Created by AMG // Noted
export const getClientUsersByClientIdAPI = async (clientId: number) => {
  return await api.get(url.CLIENT_USERS_URL, { 
    params: { 
      client_id: clientId,
      page_size: 100
    } 
  });
};

export const getAllSystemUsersAPI = async () => {
  return await api.get(`${url.CLIENT_USERS_URL}available-users/`);
};

export const createClientUserLinkAPI = async (clientId: number, userId: number) => {
    return await api.post(`${url.CLIENT_USERS_URL}attach-user/`, {
        client_id: clientId,
        user_id: userId
    });
};

export const deleteClientUserLinkAPI = async (clientUserId: number) => {
  return await api.delete(`${url.CLIENT_USERS_URL}${clientUserId}/`);
};

export const inviteClientUserAPI = async (data: {
  client_id: number;
  email: string;
  first_name: string;
  last_name: string;
  job_title?: string;
}) => {
  return await api.post(`${url.CLIENT_USERS_URL}invite/`, data);
};

export const toggleClientUserStatusAPI = async (clientUserId: number, status: string) => {
  return await api.patch(`${url.CLIENT_USERS_URL}${clientUserId}/toggle-status/`, {
    status: status
  });
};

export const validatePasswordSetupTokenAPI = async (token: string) => {
  // URL-encode token to handle special chars (e.g. +, / in base64)
  const encodedToken = encodeURIComponent(token);
  return await api.get(`${url.CLIENT_USERS_URL}public/setup-password/${encodedToken}/`);
};

export const setupClientPasswordAPI = async (token: string, data: {
  password: string;
  first_name: string;
  last_name: string;
}) => {
  return await api.post(`${url.CLIENT_USERS_URL}setup-password/`, {
    token,
    ...data
  });
};

export const fetchClientDetailAPI = async (clientId: string | number) => {
  return await api.get(`${url.CLIENTS_URL}${clientId}/`);
};

//Noted
export const updateClientStatusAPI = async (clientId: string | number, status: string) => {
  return await api.patch(`${url.CLIENTS_URL}${clientId}/`, { status: status });
};

// --- Employee Client Assignments ---
export const getClientAssignmentsAPI = async (clientId: string | number) => {
  return await api.get(`${url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL}?client_id=${clientId}`);
};

// Create a new assignment
export const createAssignmentAPI = async (data: any) => {
  return await api.post(url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL, data);
};

// Delete/Revoke assignment
export const deleteAssignmentAPI = async (id: number) => {
  return await api.delete(`${url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL}${id}/`);
};

// Fetch ALL employees (for the dropdown selection)
export const getAllEmployeesAPI = async () => {
    return await api.get(url.GET_ALL_EMPLOYEES); 
};

// Update Client Assignment Status
export const updateAssignmentAPI = async (id: number, data: any) => {
    return await api.patch(`${url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL}${id}/`, data);
};

// Template Builder API Calls
export const getAllTemplatesAPI = async (active?: boolean) => {
  const params = active !== undefined ? `?active=${active}` : '';
  return await api.get(`${url.TEMPLATES_URL}${params}`);
};

export const getTemplateAPI = async (templateId: number) => {
  return await api.get(`${url.TEMPLATES_URL}${templateId}/`);
};

export const createTemplateAPI = async (data: CreateTemplateData) => {
  return await api.post(url.TEMPLATES_URL, data);
};

export const updateTemplateAPI = async (templateId: number, data: UpdateTemplateData) => {
  return await api.update(`${url.TEMPLATES_URL}${templateId}/`, data);
};

export const deleteTemplateAPI = async (templateId: number) => {
  return await api.delete(`${url.TEMPLATES_URL}${templateId}/`);
};

export const getTemplateQuestionsAPI = async (templateId: number) => {
  return await api.get(`${url.QUESTIONS_TEMPLATE_URL}?template_id=${templateId}`);
};

export const getTemplateQuestionAPI = async (questionId: number) => {
  return await api.get(`${url.QUESTIONS_TEMPLATE_URL}${questionId}/`);
};

export const createTemplateQuestionAPI = async (data: CreateQuestionData) => {
  return await api.post(url.QUESTIONS_TEMPLATE_URL, data);
};

export const updateTemplateQuestionAPI = async (questionId: number, data: UpdateQuestionData) => {
  return await api.update(`${url.QUESTIONS_TEMPLATE_URL}${questionId}/`, data);
};

export const deleteTemplateQuestionAPI = async (questionId: number) => {
  return await api.delete(`${url.QUESTIONS_TEMPLATE_URL}${questionId}/`);
};

export const getAllAppraisalCyclesAPI = async (active?: boolean) => {
  const params = active !== undefined ? `?active=${active}` : "";
  return await api.get(`${url.APPRAISAL_CYCLES_URL}${params}`);
};

export const getAppraisalCycleAPI = async (cycleId: number) => {
  return await api.get(`${url.APPRAISAL_CYCLES_URL}${cycleId}/`);
};

export const createAppraisalCycleAPI = async (data: CreateAppraisalCycleData) => {
  return await api.post(url.APPRAISAL_CYCLES_URL, data);
};

export const updateAppraisalCycleAPI = async (cycleId: number, data: UpdateAppraisalCycleData) => {
  return await api.update(`${url.APPRAISAL_CYCLES_URL}${cycleId}/`, data);
};

export const deleteAppraisalCycleAPI = async (cycleId: number) => {
  return await api.delete(`${url.APPRAISAL_CYCLES_URL}${cycleId}/`);
};

export const generateCycleReportAPI = async (cycleId: number): Promise<Blob> => {
  const response = await api.getBlob(`${url.GENERATE_CYCLE_REPORT_URL}${cycleId}/generate-report/`);
  return response.data;
};

export const viewCycleReportAPI = async (cycleId: number): Promise<AxiosResponse<any>> => {
  return await api.get(`${url.VIEW_CYCLE_REPORT_URL}${cycleId}/view-report/`);
};

export const getAvailableCyclesAPI = async (): Promise<AxiosResponse<AvailableCycle[]>> => {
  return await api.get(url.APPRAISAL_RESPONSE_CYCLES_AVAILABLE_URL);
};

export const getCycleDetailAPI = async (cycleId: number): Promise<AxiosResponse<AvailableCycle>> => {
  return await api.get(`${url.APPRAISAL_RESPONSE_CYCLE_DETAIL_URL}${cycleId}/`);
};

export const getCycleEmployeesStatusAPI = async (cycleId: number): Promise<AxiosResponse<{ completed: any[], pending: any[] }>> => {
  return await api.get(`${url.APPRAISAL_RESPONSE_CYCLE_EMPLOYEES_STATUS_URL}${cycleId}/employees/status/`);
};

export const getEmployeeResponseAPI = async (cycleId: number, employeeId: number): Promise<AxiosResponse<{ data: AppraisalResponse | null }>> => {
  return await api.get(`${url.APPRAISAL_RESPONSE_EMPLOYEE_RESPONSE_URL}${cycleId}/employees/${employeeId}/`);
};

export const getMyAppraisalResponsesAPI = async (status?: 'DRAFT' | 'SUBMITTED'): Promise<AxiosResponse<AppraisalResponse[]>> => {
  const params = status ? `?status=${status}` : "";
  return await api.get(`${url.APPRAISAL_RESPONSE_URL}${params}`);
};

export const getAppraisalResponseAPI = async (responseId: number): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.get(`${url.APPRAISAL_RESPONSE_URL}${responseId}/`);
};

export const createOrUpdateAppraisalResponseAPI = async (data: CreateAppraisalResponseData): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.post(url.APPRAISAL_RESPONSE_URL, data);
};

export const submitAppraisalResponseAPI = async (responseId: number): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.post(`${url.APPRAISAL_RESPONSE_URL}${responseId}/submit/`);
};

export const getEmployeeSelfReviewCyclesAPI = async (): Promise<AxiosResponse<AvailableCycle[]>> => {
  return await api.get(url.EMPLOYEE_SELF_REVIEW_CYCLES_URL);
};

export const getEmployeePeerReviewCyclesAPI = async (): Promise<AxiosResponse<AvailableCycle[]>> => {
  return await api.get(url.EMPLOYEE_PEER_REVIEW_CYCLES_URL);
};

export const getEmployeeCycleDetailAPI = async (cycleId: number, reviewType: 'self' | 'peer'): Promise<AxiosResponse<AvailableCycle>> => {
  return await api.get(`${url.EMPLOYEE_CYCLE_DETAIL_URL}${cycleId}/?review_type=${reviewType}`);
};

export const getEmployeePeerReviewEmployeesAPI = async (cycleId: number): Promise<AxiosResponse<{ completed: any[], pending: any[] }>> => {
  return await api.get(`${url.EMPLOYEE_PEER_REVIEW_EMPLOYEES_URL}${cycleId}/peer-employees/`);
};

export const getEmployeeSelfResponseAPI = async (cycleId: number): Promise<AxiosResponse<{ data: AppraisalResponse | null }>> => {
  return await api.get(`${url.EMPLOYEE_SELF_RESPONSE_URL}${cycleId}/self-response/`);
};

export const getEmployeePeerResponseAPI = async (cycleId: number, employeeId: number): Promise<AxiosResponse<{ data: AppraisalResponse | null }>> => {
  return await api.get(`${url.EMPLOYEE_PEER_RESPONSE_URL}${cycleId}/peer-response/${employeeId}/`);
};

export const getEmployeeAppraisalResponsesAPI = async (reviewerType: 'SELF' | 'PEER', status?: 'DRAFT' | 'SUBMITTED'): Promise<AxiosResponse<AppraisalResponse[]>> => {
  const params = new URLSearchParams();
  params.append('reviewer_type', reviewerType);
  if (status) {
    params.append('status', status);
  }
  return await api.get(`${url.EMPLOYEE_APPRAISAL_RESPONSES_URL}?${params.toString()}`);
};

export const getEmployeeAppraisalResponseAPI = async (responseId: number): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.get(`${url.EMPLOYEE_APPRAISAL_RESPONSE_DETAIL_URL}${responseId}/`);
};

export const createOrUpdateEmployeeAppraisalResponseAPI = async (data: CreateAppraisalResponseData): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.post(url.EMPLOYEE_APPRAISAL_RESPONSES_URL, data);
};

export const submitEmployeeAppraisalResponseAPI = async (responseId: number): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.post(`${url.EMPLOYEE_SUBMIT_RESPONSE_URL}${responseId}/submit/`);
};

export const getManagerAvailableCyclesAPI = async (): Promise<AxiosResponse<AvailableCycle[]>> => {
  return await api.get(url.MANAGER_AVAILABLE_CYCLES_URL);
};

export const getManagerCycleDetailAPI = async (cycleId: number): Promise<AxiosResponse<AvailableCycle>> => {
  return await api.get(`${url.MANAGER_CYCLE_DETAIL_URL}${cycleId}/`);
};

export const getManagerCycleEmployeesStatusAPI = async (cycleId: number): Promise<AxiosResponse<{ completed: any[], pending: any[] }>> => {
  return await api.get(`${url.MANAGER_CYCLE_EMPLOYEES_STATUS_URL}${cycleId}/employees/status/`);
};

export const getManagerEmployeeResponseAPI = async (cycleId: number, employeeId: number): Promise<AxiosResponse<{ data: AppraisalResponse | null }>> => {
  return await api.get(`${url.MANAGER_EMPLOYEE_RESPONSE_URL}${cycleId}/employees/${employeeId}/`);
};

export const getManagerTeamMemberResponsesAPI = async (cycleId: number, employeeId: number): Promise<AxiosResponse<AppraisalResponse[]>> => {
  return await api.get(`${url.MANAGER_TEAM_MEMBER_RESPONSES_URL}${cycleId}/employees/${employeeId}/all-responses/`);
};

export const getManagerAppraisalResponsesAPI = async (status?: 'DRAFT' | 'SUBMITTED'): Promise<AxiosResponse<AppraisalResponse[]>> => {
  const params = status ? `?status=${status}` : "";
  return await api.get(`${url.MANAGER_APPRAISAL_RESPONSES_URL}${params}`);
};

export const createOrUpdateManagerAppraisalResponseAPI = async (data: CreateAppraisalResponseData): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.post(url.MANAGER_APPRAISAL_RESPONSES_URL, data);
};

export const getManagerAppraisalResponseAPI = async (responseId: number): Promise<AxiosResponse<AppraisalResponse>> => {
  return await api.get(`${url.MANAGER_APPRAISAL_RESPONSE_DETAIL_URL}${responseId}/`);
};

export const getPeerReviewNominationsAPI = async (cycleId: number): Promise<AxiosResponse<any[]>> => {
  return await api.get(`${url.PEER_REVIEW_NOMINATIONS_URL}${cycleId}/peer-nominations/`);
};

export const createPeerReviewNominationsAPI = async (cycleId: number, nominations: { reviewer_id: number; reviewee_id: number }[]): Promise<AxiosResponse<any[]>> => {
  return await api.post(`${url.PEER_REVIEW_NOMINATIONS_URL}${cycleId}/peer-nominations/`, { nominations });
};

export const deletePeerReviewNominationAPI = async (cycleId: number, nominationId: number): Promise<AxiosResponse<void>> => {
  return await api.delete(`${url.PEER_REVIEW_NOMINATION_DETAIL_URL}${cycleId}/peer-nominations/${nominationId}/`);
};

// ==========================================
// Client Management & Scheduling APIs
// ==========================================

export const getEmployeeAssignmentsAPI = async (employeeId: number): Promise<AxiosResponse<any>> => {
  // Use the existing constant. Assuming this endpoint supports filtering by query param.
  return await api.get(`${url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL}?employee_id=${employeeId}`);
};

// src/api/apiHelper.ts

export const getMyEmployeesAssignmentsAPI = () => {
  // Uses the central URL constant instead of a hardcoded string
  return api.get(`${url.EMPLOYEE_CLIENT_ASSIGNMENTS_URL}by-current-user/`);
};

export const updateAssignmentScheduleAPI = async (assignmentId: number, data: any): Promise<AxiosResponse<any>> => {
  // Construct the URL: /clients/assignments/{id}/schedule/
  // Ensure this matches your Django 'client_management/urls.py'
  return await api.patch(`${url.CLIENT_ASSIGNMENT_BASE_URL}${assignmentId}/schedule/`, data);
};

// ==========================================
// Client Portal APIs (For the Client User)
// ==========================================

export const getClientPendingReviewsAPI = async (): Promise<AxiosResponse<any[]>> => {
  return await api.get(url.CLIENT_PORTAL_PENDING_REVIEWS_URL);
};

export const getClientReviewDetailAPI = async (reviewId: number): Promise<AxiosResponse<any>> => {
  return await api.get(`${url.CLIENT_PORTAL_SUBMIT_REVIEW_URL}${reviewId}/`);
};

export const submitClientReviewAPI = async (reviewId: number, answers: any[]): Promise<AxiosResponse<any>> => {
  // Payload: { answers: [...] }
  return await api.post(`${url.CLIENT_PORTAL_SUBMIT_REVIEW_URL}${reviewId}/`, { answers });
};

export const lockUnlockCycleAPI = async (cycleId: number, action: 'lock' | 'unlock'): Promise<AxiosResponse<{ message: string; locked: boolean }>> => {
  return await api.post(`${url.LOCK_UNLOCK_CYCLE_URL}${cycleId}/lock-unlock/`, { action });
};

export const getClientReviewAssignmentsAPI = (cycleId: number) => {
  return api.get(url.CLIENT_ASSIGNMENT_LIST_CREATE_URL(cycleId));
};

/**
 * Syncs the "checked" list of employees for a client in a cycle.
 * data: { client_id: number, reviewee_ids: number[] }
 */
export const bulkSyncClientAssignmentsAPI = (cycleId: number, data: { client_id: number, reviewee_ids: number[] }) => {
  return api.post(url.CLIENT_ASSIGNMENT_BULK_SYNC_URL(cycleId), data);
};


// --- Client Side: Portal Dashboard ---

/**
 * Fetches only the cycles assigned to the logged-in client (used by Client)
 * This replaces the old getAvailableCyclesAPI for the client portal.
 */
export const getClientAssignedCyclesAPI = () => {
  return api.get(url.CLIENT_ASSIGNED_CYCLES_URL);
};